export default "/images/purchasing.png?3e1cc6b17120ccb9c2cc620f46c04f28";